import { render } from "./UserAvatar.vue?vue&type=template&id=4967692f&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=4967692f&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4967692f"]])

export default __exports__